import { useState } from 'react';
import { Modal } from './common';
import { IconEdit, IconTrash } from './icons';

/**
 * The แก้ไข / ลบ pair that every ตั้งค่า row carries.
 *
 * Deleting asks first and says what will actually happen: most of these tables
 * retire a row rather than erase it, because a service that has been sold still
 * has to render on last month's bill.
 */
export default function RowActions({ label, name, onEdit, onDelete, disabled }) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const go = async () => {
    setBusy(true);
    setError(null);
    try {
      await onDelete();
      setConfirming(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="row-actions" onClick={(e) => e.stopPropagation()}>
      {onEdit && (
        <button className="icon-square" title="แก้ไข" onClick={onEdit} disabled={disabled}>
          <IconEdit size={16} />
        </button>
      )}
      {onDelete && (
        <button
          className="icon-square danger"
          title="ลบ"
          onClick={() => setConfirming(true)}
          disabled={disabled}
        >
          <IconTrash size={16} />
        </button>
      )}

      {confirming && (
        <Modal
          title={`ลบ${label || 'รายการ'}`}
          onClose={() => setConfirming(false)}
          footer={
            <>
              <button className="btn-outline" onClick={() => setConfirming(false)} disabled={busy}>
                ยกเลิก
              </button>
              <button className="btn-danger" onClick={go} disabled={busy}>
                {busy ? 'กำลังลบ…' : 'ลบ'}
              </button>
            </>
          }
        >
          {error && <div className="login-error">{error}</div>}
          <p style={{ margin: 0, lineHeight: 1.8 }}>
            ต้องการลบ <strong>{name}</strong> ใช่หรือไม่?
            <br />
            <span style={{ color: 'var(--ink-500)', fontSize: 13 }}>
              รายการที่เคยถูกใช้งานจะถูกปิดการใช้งานแทนการลบ เพื่อไม่ให้บิลเก่าเสียหาย
            </span>
          </p>
        </Modal>
      )}
    </span>
  );
}
